export default "__VITE_ASSET__54e09486__"